import store from '../store';

class MenuBuilder {
    public getNavItems() {
        const navItems = [];
        navItems.push({ icon: 'home', title: 'Home', to: { name: 'home' } });
        if (store.state.token) {
            navItems.push({ icon: 'directions_bike', title: 'Activities', to: { name: 'activitySummary', params: { sort: 'start_date', direction: 'desc' } } });
            navItems.push({ icon: 'calendar_today', title: 'Monthly summary', to: { name: 'activityMonthSummaryView', params: {} } });
        }
        return navItems;
    }
}

const menuBuilder = new MenuBuilder();

export default menuBuilder;
